import { LOGIN_PATH } from 'constants/navigation';
import { getCurrentUrl } from 'utils/window';

class SocialNetworks {
  courseTitle: any;

  authStorageUrl: any;

  location: any;

  constructor(courseTitle: any, authStorageUrl: any) {
    this.courseTitle = courseTitle;
    this.authStorageUrl = authStorageUrl;
    this.location = `${getCurrentUrl()}#${LOGIN_PATH}`;
  }

  getAuthLink(socialNetwork: any) {
    const addTokenQueryParam =
      window.location.host.indexOf('easygenerator.com') === -1 ? '&addTokenQuery=true' : '';
    return `${this.authStorageUrl}/api/auth/${socialNetwork}?callbackUrl=${encodeURIComponent(
      this.location
    )}${addTokenQueryParam}`;
  }
}

export default SocialNetworks;
